import { TDocument, TUseDocumentResult } from '../documents/types';
import { TSparseItem } from '../items/types/folders.types';
import { TPath } from '../items/types/folders.types';

import { TFile, TUseFileResult } from '@modules/files';
import { TStats } from '@modules/items';
import { AccessType, TPermissions } from '@modules/access';

/** Lightweight replica reference for sidebar display. */
export type TSparseReplica = TSparseItem & {
  versionId?: string; // present = SPECIFIC (pinned to this version), absent = AUTO
};

export type TReplicaVersionMode = 'AUTO' | 'SPECIFIC';

export type TReplica = {
  _id: string;
  active: boolean;
  archived: boolean;
  organization: string;
  name: string;
  master: string;
  stats: TStats;
  resolvedPath: TPath;
  type: 'REPLICA_DOCUMENT' | 'REPLICA_FILE';
  isFrozen: boolean;
  versionMode: TReplicaVersionMode;
  versionId?: string;
};

export type TMasterData = TUseDocumentResult | TUseFileResult;

export const getMasterFromData = (masterData: TMasterData): TDocument | TFile =>
  (masterData as TUseDocumentResult).doc || (masterData as TUseFileResult).file;

export type TUseReplicaResult = {
  replica: TReplica;
  masterData: TMasterData;
  accessRight: AccessType;
  permissions: TPermissions;
};
